/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=acb735c2&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=acb735c2&lang=css"
import "./App.vue?vue&type=style&index=1&id=acb735c2&scoped=true&lang=css"

import exportComponent from "D:\\项目\\huashiAdmin\\hsng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb735c2"]])

export default __exports__